var React = require('react');

function Quote (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},[React.createElement("style",{"key":0},".a{fill:none;}.b{clip-path:url(#a);}.c{fill:#e33b30;}"),React.createElement("clipPath",{"id":"a","key":1},React.createElement("rect",{"className":"a","width":"49.285","height":"43.106"}))]),React.createElement("g",{"className":"b","transform":"translate(0 0)","key":1},React.createElement("path",{"className":"c","d":"M1306.855,3853.008v21.062h-21.2v-21.062c0-11.935,5.9-18.674,13.621-22.044l5.2,8.845c-4.915,2.1-8.425,5.616-8.425,13.2Zm28.082,0v21.062h-21.2v-21.062c0-11.935,5.9-18.674,13.621-22.044l5.2,8.845c-4.915,2.1-8.425,5.616-8.425,13.2Z","transform":"translate(-1285.652 -3830.964)"}))]);
}

Quote.defaultProps = {"width":"49.285","height":"43.106","viewBox":"0 0 49.285 43.106"};

module.exports = Quote;

Quote.default = Quote;
